import { render } from "./opportunity.vue?vue&type=template&id=2c6591ac&scoped=true"
import script from "./opportunity.vue?vue&type=script&lang=js"
export * from "./opportunity.vue?vue&type=script&lang=js"

import "./opportunity.vue?vue&type=style&index=0&id=2c6591ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c6591ac"

export default script